// src/components/destination-neighborhoods/destination-neighborhoods.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      resource {\n        value\n      }\n      analytics {\n        referrerId\n        linkName\n      }\n      target\n    }\n    text\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardAttributionFragment on EGDSSpannableText {\n    contents {\n      text\n      ... on EGDSStandardLink {\n        ...EGDSStandardLinkFragment\n      }\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardImageFragment on DestinationRecommendationCardImage {\n    attribution {\n      ...DestinationRecommendationCardAttributionFragment\n    }\n    image {\n      aspectRatio\n      description\n      url\n    }\n    impression {\n      eventType\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardMediaFragment on DestinationRecommendationCardMedia {\n    ... on DestinationRecommendationCardImage {\n      ...DestinationRecommendationCardImageFragment\n    }\n    ... on DestinationRecommendationCardImages {\n      images {\n        ...DestinationRecommendationCardImageFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardFragment on DestinationRecommendationCard {\n    heading {\n      title\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      analytics {\n        referrerId\n        linkName\n      }\n      resource {\n        value\n      }\n    }\n    media {\n      ...DestinationRecommendationCardMediaFragment\n    }\n    details {\n      content {\n        ...EGDSParagraphFragment\n      }\n      link {\n        ...EGDSStandardLinkFragment\n      }\n      heading {\n        title\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  query DestinationNeighborhoodsQuery($destinationNeighborhoodsContextInput: DestinationNeighborhoodsContextInput!, $context: ContextInput!) {\n    destinationNeighborhoods(destinationNeighborhoodsContextInput: $destinationNeighborhoodsContextInput, context: $context) {\n      heading {\n        title\n      }\n      cards {\n        ...DestinationRecommendationCardFragment\n      }\n      carousel {\n        ...EGDSCarouselFragment\n      }\n      impression {\n        eventType\n        linkName\n        referrerId\n      }\n      interaction {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
import React9 from "react";
import { gql as gql8, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// src/components/destination-neighborhoods/__private/__fragments/card/destination-recommendation-card.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// src/components/destination-neighborhoods/__private/__fragments/card/egds-paragraph.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var __fragment = gql(_templateObject());
var EGDSParagraph = function(param) {
    var data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React.createElement(UitkParagraph, null, text);
};
EGDSParagraph.fragment = __fragment;
EGDSParagraph.displayName = "EGDSParagraph";
// src/components/destination-neighborhoods/__private/__fragments/card/egds-standard-link.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
var __fragment2 = gql2(_templateObject1());
var EGDSStandardLink = function(param) {
    var data = param.data, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? true : _param_showIcon, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme, _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? true : _param_enableTracking;
    var action = data.action, text = data.text;
    var resource = action.resource, accessibility = action.accessibility, target = action.target, analytics = action.analytics;
    var clickTracker = useClickTracker();
    var trackEvent = React2.useCallback(function() {
        if (enableTracking) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker,
        enableTracking
    ]);
    var linkTarget = target === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self";
    return /* @__PURE__ */ React2.createElement(UitkLink, {
        onClickCapture: trackEvent,
        theme: theme
    }, /* @__PURE__ */ React2.createElement("a", {
        target: linkTarget,
        rel: "noopener",
        href: resource.value,
        "aria-label": accessibility || ""
    }, text, showIcon && /* @__PURE__ */ React2.createElement(UitkIcon, {
        "data-stid": "lodging-link-message-icon",
        name: "arrow_forward",
        size: UitkIconSize.EXTRA_SMALL
    }), accessibility && /* @__PURE__ */ React2.createElement(UitkText, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = __fragment2;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/destination-neighborhoods/__private/__fragments/card/media/destination-recommendation-card-media.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// src/components/destination-neighborhoods/__private/__fragments/egds-carousel.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
// src/components/destination-neighborhoods/__private/__fragments/card/media/destination-recommendation-card-image.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
// src/components/destination-neighborhoods/__private/__fragments/utility/image-aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj;
var UitkImageAspectRatioMap = Object.freeze((_obj = {}, _define_property(_obj, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj));
// src/components/destination-neighborhoods/__private/__fragments/card/media/destination-recommendation-card-attribution.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkText as UitkText2 } from "uitk-react-text";
var __fragment3 = gql3(_templateObject2(), EGDSStandardLink.fragment);
var DestinationRecommendationCardAttribution = function(param) {
    var data = param.data;
    var text = data.text, contents = data.contents;
    return /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        columns: [
            "1fr",
            "min-content"
        ],
        space: "one",
        alignItems: "center",
        justifyItems: "start"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React3.createElement(UitkLayoutPosition, {
        type: "relative",
        position: {
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        justifyContent: "start",
        alignItems: "center",
        space: "one",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        switch(content === null || content === void 0 ? void 0 : content.__typename){
            case "EGDSStandardLink":
                return /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
                    key: "detail-attribution-link-".concat(index),
                    justifyContent: "end",
                    alignItems: "center",
                    space: "one"
                }, /* @__PURE__ */ React3.createElement(EGDSStandardLink, {
                    data: content,
                    theme: "inverse",
                    showIcon: false,
                    enableTracking: false
                }));
            default:
                return /* @__PURE__ */ React3.createElement(UitkText2, {
                    key: "detail-attribution-text-".concat(index),
                    theme: "inverse",
                    size: 100,
                    overflow: "truncate"
                }, content.text);
        }
    }), /* @__PURE__ */ React3.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, text)))));
};
DestinationRecommendationCardAttribution.fragment = __fragment3;
DestinationRecommendationCardAttribution.displayName = "DestinationRecommendationCardAttribution";
// src/components/destination-neighborhoods/__private/__fragments/card/media/destination-recommendation-card-image.tsx
var DEFAULT_ASPECT_RATIO = {
    desktop: "ONE_ONE" /* ONE_ONE */ ,
    mobile: "THREE_FOUR" /* THREE_FOUR */ 
};
var __fragment4 = gql4(_templateObject3(), DestinationRecommendationCardAttribution.fragment);
var DestinationRecommendationCardImage = function(param) {
    var data = param.data;
    var image = data.image, attribution = data.attribution, impression = data.impression;
    var _ref = image || {}, description = _ref.description, url = _ref.url, aspectRatio = _ref.aspectRatio;
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var isSmall = viewSize === defaultViewSizes.SMALL;
    var defaultRatio = isSmall ? DEFAULT_ASPECT_RATIO.mobile : DEFAULT_ASPECT_RATIO.desktop;
    var ratio = UitkImageAspectRatioMap[aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : defaultRatio];
    return /* @__PURE__ */ React4.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: (impression === null || impression === void 0 ? void 0 : impression.referrerId) || "",
        linkName: (impression === null || impression === void 0 ? void 0 : impression.linkName) || ""
    }, /* @__PURE__ */ React4.createElement(UitkFigure, {
        roundcorner: true,
        ratio: ratio,
        style: {
            maxHeight: "25rem",
            borderRadius: isSmall ? "1rem" : "0.25rem"
        }
    }, image && /* @__PURE__ */ React4.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url,
        lazyLoading: "lazy"
    }), /* @__PURE__ */ React4.createElement(UitkScrim, {
        type: UitkScrimType.BOTTOM
    }, /* @__PURE__ */ React4.createElement(UitkLayoutPosition2, {
        type: "relative",
        position: {
            zindex: "layer3"
        },
        display: "block"
    }, attribution && /* @__PURE__ */ React4.createElement(DestinationRecommendationCardAttribution, {
        data: attribution
    })))));
};
DestinationRecommendationCardImage.fragment = __fragment4;
DestinationRecommendationCardImage.displayName = "DestinationRecommendationCardImage";
// src/components/destination-neighborhoods/__private/__fragments/egds-carousel.tsx
var __fragment5 = gql5(_templateObject4());
var EGDSCarousel = function(param) {
    var carouselName = param.carouselName, data = param.data, carouselContent = param.carouselContent;
    var trackerEvent = useClickTracker2();
    var viewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    var itemsVisible = React5.useMemo(function() {
        return {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 3
        };
    }, [
        viewSize
    ]);
    var nextButton = data.nextButton, previousButton = data.previousButton;
    var lastIndex = React5.useRef(0);
    var onIndexChange = React5.useCallback(function(index) {
        var _button_analytics, _button_analytics1;
        if (lastIndex.current === 0 && index === 0) {
            return;
        }
        var button = index >= lastIndex.current ? nextButton : previousButton;
        var _button_analytics_referrerId, _button_analytics_linkName;
        trackerEvent((_button_analytics_referrerId = button === null || button === void 0 ? void 0 : (_button_analytics = button.analytics) === null || _button_analytics === void 0 ? void 0 : _button_analytics.referrerId) !== null && _button_analytics_referrerId !== void 0 ? _button_analytics_referrerId : "", (_button_analytics_linkName = button === null || button === void 0 ? void 0 : (_button_analytics1 = button.analytics) === null || _button_analytics1 === void 0 ? void 0 : _button_analytics1.linkName) !== null && _button_analytics_linkName !== void 0 ? _button_analytics_linkName : "");
        lastIndex.current = index;
    }, [
        nextButton,
        previousButton,
        lastIndex,
        trackerEvent
    ]);
    if (!carouselContent) {
        return null;
    }
    var _nextButton_accessibility, _previousButton_accessibility;
    return /* @__PURE__ */ React5.createElement(UitkCarousel, {
        carouselName: carouselName,
        startIndex: 0,
        navigationIconId: {
            next: "".concat(carouselName, ".").concat(nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility),
            prev: "".concat(carouselName, ".").concat(previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility)
        },
        buttonText: {
            nextButton: (_nextButton_accessibility = nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) !== null && _nextButton_accessibility !== void 0 ? _nextButton_accessibility : "",
            prevButton: (_previousButton_accessibility = previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) !== null && _previousButton_accessibility !== void 0 ? _previousButton_accessibility : ""
        },
        itemsVisible: itemsVisible,
        pageBy: 1,
        peek: true,
        pagingInset: true,
        onIndexChange: onIndexChange
    }, carouselContent.filter(function(item) {
        return item && item.__typename === "DestinationRecommendationCardImage";
    }).map(function(item, index) {
        return /* @__PURE__ */ React5.createElement(DestinationRecommendationCardImage, {
            key: index,
            data: item
        });
    }));
};
EGDSCarousel.fragment = __fragment5;
EGDSCarousel.displayName = "EGDSCarousel";
// src/components/destination-neighborhoods/__private/__fragments/card/media/destination-recommendation-card-media.tsx
var __fragment6 = gql6(_templateObject5(), DestinationRecommendationCardImage.fragment);
var DestinationRecommendationCardMedia = function(props) {
    var data = props.data, carousel = props.carousel, carouselName = props.carouselName;
    var __typename = data.__typename;
    switch(__typename){
        case "DestinationRecommendationCardImages":
            return carousel ? /* @__PURE__ */ React6.createElement(EGDSCarousel, {
                data: carousel,
                carouselContent: data.images,
                carouselName: carouselName
            }) : null;
        default:
            return /* @__PURE__ */ React6.createElement(DestinationRecommendationCardImage, {
                data: data
            });
    }
};
DestinationRecommendationCardMedia.fragment = __fragment6;
DestinationRecommendationCardMedia.displayName = "DestinationRecommendationCardMedia";
// src/components/destination-neighborhoods/__private/__fragments/card/destination-recommendation-card.tsx
var __fragment7 = gql7(_templateObject6(), DestinationRecommendationCardMedia.fragment, EGDSStandardLink.fragment, EGDSParagraph.fragment);
var DestinationRecommendationCard = function(props) {
    var data = props.data, carousel = props.carousel, carouselName = props.carouselName;
    var media = data.media, details = data.details, analytics = data.analytics;
    return /* @__PURE__ */ React7.createElement(IntersectionTracker2, {
        trackOnce: false,
        referrerId: analytics.referrerId,
        linkName: analytics.linkName
    }, /* @__PURE__ */ React7.createElement(UitkSpacing, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React7.createElement(DestinationRecommendationCardMedia, {
        data: media,
        carousel: carousel,
        carouselName: carouselName
    })), details.map(function(detail, detailsIndex) {
        return /* @__PURE__ */ React7.createElement(React7.Fragment, {
            key: "detail-item-".concat(detailsIndex)
        }, detail.heading && /* @__PURE__ */ React7.createElement(UitkSpacing, {
            margin: {
                blockstart: "six",
                inlineend: "six"
            }
        }, /* @__PURE__ */ React7.createElement(UitkHeading, {
            size: 6
        }, detail.heading.title)), detail.content && /* @__PURE__ */ React7.createElement(UitkSpacing, {
            margin: {
                blockstart: "four",
                inlineend: "six"
            }
        }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(EGDSParagraph, {
            data: detail.content
        }))), detail.link && /* @__PURE__ */ React7.createElement(UitkSpacing, {
            margin: {
                blockstart: "four",
                inlineend: "six"
            }
        }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(EGDSStandardLink, {
            data: detail.link
        }))));
    }));
};
DestinationRecommendationCard.fragment = __fragment7;
DestinationRecommendationCard.displayName = "DestinationRecommendationCard";
// src/components/destination-neighborhoods/__private/__fragments/card/destination-recommendation-tabs.tsx
import React8 from "react";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
var DestinationRecommendationTabs = function(props) {
    var _React8_useState = _sliced_to_array(React8.useState(0), 2), selectedTabIndex = _React8_useState[0], setSelectedTabIndex = _React8_useState[1];
    var handleTabChange = function(tabIndex) {
        setSelectedTabIndex(tabIndex);
    };
    var cards = props.cards, carousel = props.carousel;
    return /* @__PURE__ */ React8.createElement(UitkTabs, {
        tabsType: UitkTabsType.NATURAL,
        role: "tablist",
        onTabSelect: handleTabChange,
        selectedTab: selectedTabIndex,
        scrollOffsetSelf: true
    }, cards.map(function(card, tabIndex) /* @__PURE__ */ {
        var _card_heading;
        var _card_heading_title;
        return React8.createElement(UitkTab, {
            key: "tab".concat(tabIndex),
            name: (_card_heading_title = (_card_heading = card.heading) === null || _card_heading === void 0 ? void 0 : _card_heading.title) !== null && _card_heading_title !== void 0 ? _card_heading_title : "",
            targetURI: "tab".concat(tabIndex)
        }, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
            padding: {
                blockstart: "four",
                inlinestart: "six"
            }
        }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(DestinationRecommendationCard, {
            data: card,
            carousel: carousel,
            key: "card".concat(tabIndex),
            carouselName: "carousel".concat(tabIndex)
        }))));
    }));
};
DestinationRecommendationTabs.displayName = "DestinationRecommendationTabs";
// src/components/destination-neighborhoods/destination-neighborhoods.tsx
var __Query = gql8(_templateObject7(), EGDSCarousel.fragment, DestinationRecommendationCard.fragment);
var DestinationNeighborhoods = function(props) {
    var _data_destinationNeighborhoods_cards;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationNeighborhoods) || !(data === null || data === void 0 ? void 0 : (_data_destinationNeighborhoods_cards = data.destinationNeighborhoods.cards) === null || _data_destinationNeighborhoods_cards === void 0 ? void 0 : _data_destinationNeighborhoods_cards.length)) {
        return null;
    }
    var destinationNeighborhoods = data.destinationNeighborhoods;
    var cards = destinationNeighborhoods.cards, impression = destinationNeighborhoods.impression, heading = destinationNeighborhoods.heading, carousel = destinationNeighborhoods.carousel;
    return /* @__PURE__ */ React9.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: impression.referrerId,
        linkName: impression.linkName
    }, /* @__PURE__ */ React9.createElement(UitkSpacing3, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React9.createElement(UitkHeading2, {
        tag: "h4",
        size: 4,
        align: "left"
    }, heading.title)), /* @__PURE__ */ React9.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(DestinationRecommendationTabs, {
        cards: cards,
        carousel: carousel
    }))));
};
DestinationNeighborhoods.displayName = "sharedui-DestinationNeighborhoods";
export { DestinationNeighborhoods };
//# sourceMappingURL=index.js.map